module.exports = __webpack_public_path__ + "static/img/98028A_1_2_C_20240425_LC.ab062e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/98028A_1_2_C_20240425_LC.png
// module id = F0Ne
// module chunks = 0